import { render } from "./CommonSkeletonLoader.vue?vue&type=template&id=1a070df8&scoped=true"
import script from "./CommonSkeletonLoader.vue?vue&type=script&lang=js"
export * from "./CommonSkeletonLoader.vue?vue&type=script&lang=js"

import "./CommonSkeletonLoader.vue?vue&type=style&index=0&id=1a070df8&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\supportgroup\\head.supportgroup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a070df8"]])

export default __exports__